import styled from 'styled-components';

import { coolGrey2 } from 'approot/shared/styles/colours.style';
import {
  spacing8,
  spacing16,
  spacing24,
} from 'approot/shared/styles/spacing.style';
import { rem } from 'approot/shared/style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';
import { SLIDES_WIDTH } from './activity-builder-slides.style';
import { skeletonState } from 'approot/shared/styles/transitions.style';
import { LAYOUT_HEADER_HEIGHT } from 'approot/shared/layout/layout.styles';
import {
  ACTIVITY_BUILDER_CANVAS_Z_INDEX,
  ACTIVITY_BUILDER_DRAWER_BREAKPOINT,
  ACTIVITY_BUILDER_DRAWER_WIDTH,
  ACTIVITY_BUILDER_HEADER_CONTAINER_Z_INDEX,
  ACTIVITY_BUILDER_SETTINGS_WIDTH,
} from './activity-builder.constants';

export const ACTIVITY_BUILDER_MIN_WIDTH_1064 = `@media (min-width: 1064px)`;

type ActivityBuilderCanvasProps = {
  $isActive: boolean;
};
export const ActivityBuilderCanvas = styled.div<ActivityBuilderCanvasProps>`
  display: flex;
  position: fixed;
  left: ${rem(SLIDES_WIDTH)};
  margin: 0;
  top: ${rem(LAYOUT_HEADER_HEIGHT)};
  bottom: 0;
  right: 0;
  overflow-y: auto;
  z-index: ${ACTIVITY_BUILDER_CANVAS_Z_INDEX};

  ${ACTIVITY_BUILDER_DRAWER_BREAKPOINT} {
    right: ${({ $isActive }) =>
      rem(
        $isActive
          ? ACTIVITY_BUILDER_DRAWER_WIDTH + ACTIVITY_BUILDER_SETTINGS_WIDTH
          : ACTIVITY_BUILDER_SETTINGS_WIDTH
      )};
  }
`;

export const ActivityBuilderHeader = styled.div`
  border-radius: ${rem(borderRadius8)} ${rem(borderRadius8)} 0 0;
  margin-bottom: ${rem(spacing24)};
  width: 100%;
  padding: 0;

  ${ACTIVITY_BUILDER_MIN_WIDTH_1064} {
    max-width: ${rem(1064)};
  }
`;

export const ActivityBuilderButtonSkeleton = styled.div`
  ${skeletonState}
  border-radius: ${rem(borderRadius8)};
  background-color: ${coolGrey2};
  height: ${rem(40)};
  width: ${rem(120)};
`;

export const ActivityBuilderHeaderButtons = styled.div`
  display: flex;
  gap: ${rem(spacing8)};
`;

export const ActivityBuilderSecondaryHeaderButtons = styled(
  ActivityBuilderHeaderButtons
)`
  display: flex;
  align-items: center;
  position: absolute;
  right: ${rem(spacing16)};
`;

export const ActivityBuilderHeaderContainer = styled.div`
  ${flexCentreAlignCss}
  position: absolute;
  left: 0;
  right: 0;
  z-index: ${ACTIVITY_BUILDER_HEADER_CONTAINER_Z_INDEX};
`;

export const ActivityBuilderContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ActivityBuilderContainerSlide = styled.div`
  width: 100%;
`;
